/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2025-03-06 14:58:24
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-07-08 11:09:13
 */
import Cookies from 'js-cookie';
const TokenKey = 'ManageToken';
const TokenPrefix = 'Bearer ';
const isLogin = () => {
  return !!Cookies.get(TokenKey);
};
const getToken = () => {
  return Cookies.get(TokenKey);
};
const setToken = (token: string) => {
  Cookies.set(
    TokenKey,
    TokenPrefix + token,
    1,
    '/',
    // domain
  );
};
const clearToken = () => {
  // localStorage.removeItem(TokenKey);
  removeCookie(TokenKey);
};

const removeCookie = (key: string) => {
  Cookies.remove(key, {
    path: '/',
    // domain: domain
  });
  localStorage.clear();
  sessionStorage.clear();
};
export { TokenPrefix, isLogin, getToken, setToken, clearToken };
